const STORAGE_KEY = 'dvn.partnerCatalogToken';

export function setPartnerCatalogToken(token) {
  if (typeof window === 'undefined') return;
  const normalized = String(token || '').trim().toLowerCase();
  if (normalized) {
    window.sessionStorage.setItem(STORAGE_KEY, normalized);
  }
}

export function getPartnerCatalogToken() {
  if (typeof window === 'undefined') return null;
  const value = window.sessionStorage.getItem(STORAGE_KEY);
  return value || null;
}

export function clearPartnerCatalogToken() {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(STORAGE_KEY);
}

export function getPartnerCatalogPath() {
  const token = getPartnerCatalogToken();
  return token ? `/p/${token}` : null;
}

/** Packages list route: partner catalog when session has a catalog token, else marketplace. */
export function getPackagesListingPath() {
  return getPartnerCatalogPath() || '/deals?tab=packages';
}

export function isPartnerCatalogPath(pathname) {
  const path = String(pathname || '');
  return path === '/p' || path.startsWith('/p/');
}
